import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  totalCount: null,
  entities: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const buyerAssetSlice = createSlice({
  name: "buyerAsset",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    buyerAssetListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    buyerAssetList: (state, action) => {
      const { result, count } = action.payload;

      const arr = [];

      result.map(index => {
        if (index.lastOffer !== index.asset.sellingPrice) arr.push(index);
      });
      state.totalCount = count;
      state.entities = arr;
      state.listLoader = false;
    },
    enquiryAssetList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
  },
});
